module.exports = __webpack_public_path__ + "assets/images/0c6d5cda489f59ae2ae064fd87565546.png";